import React from "react";
import PayKycService from "./pay-kyc-service";
import CreatePayKyc from "./create-pay-kyc";
import UpdatePayKyc from "./update-pay-kyc";

const EmployeePayKyc = () => {
  const {
    paymentData,
    onChangePayment,
    OnBlurePayment,
    paymentErr,
    onSubmitPayKyc,
    onChangeKYCdoc,
    alldocs,
    kycDoc,
    fileInputRef,
    handleButtonClick,
    handleFileChange,
    DeleteSpecificFile,
    openFileInNewTab,
    checkDocName,
    paymentModal,
    PaymentModalToggle,
    onUpdatePayKyc,
    paymentloader,
    kycModalToggle,
    kycMOdal
  } = PayKycService();

  return (
    <>
      {paymentData?.employee_pay_and_kyc_id ? (
        <>
        
        <UpdatePayKyc
          paymentData={paymentData}
          onChangePayment={onChangePayment}
          OnBlurePayment={OnBlurePayment}
          paymentErr={paymentErr}
          onSubmitPayKyc={onSubmitPayKyc}
          onChangeKYCdoc={onChangeKYCdoc}
          alldocs={alldocs}
          kycDoc={kycDoc}
          fileInputRef={fileInputRef}
          handleButtonClick={handleButtonClick}
          handleFileChange={handleFileChange}
          DeleteSpecificFile={DeleteSpecificFile}
          openFileInNewTab={openFileInNewTab}
          checkDocName={checkDocName}
          paymentModal={paymentModal}
          PaymentModalToggle={PaymentModalToggle}
          onUpdatePayKyc={onUpdatePayKyc}
          paymentloader={paymentloader}
          kycModalToggle={kycModalToggle}
          kycMOdal={kycMOdal}
        />
        </>
      ) : (
        <>
   
          <CreatePayKyc
            paymentData={paymentData}
            onChangePayment={onChangePayment}
            OnBlurePayment={OnBlurePayment}
            paymentErr={paymentErr}
            onSubmitPayKyc={onSubmitPayKyc}
            onChangeKYCdoc={onChangeKYCdoc}
            alldocs={alldocs}
            kycDoc={kycDoc}
            fileInputRef={fileInputRef}
            handleButtonClick={handleButtonClick}
            handleFileChange={handleFileChange}
            DeleteSpecificFile={DeleteSpecificFile}
            openFileInNewTab={openFileInNewTab}
            checkDocName={checkDocName}
          />
        </>
      )}
    </>
  );
};

export default EmployeePayKyc;
